import React from 'react'
import Flatpickr from 'react-flatpickr'
import { Greek } from 'flatpickr/dist/l10n/gr'
import 'flatpickr/dist/themes/light.css'
import { Form, Button } from 'react-bootstrap'

const TimePicker = ({
    value,
    onChange,
    disabled,
    label,
    showClearButton = true,
    onClear,
    isInvalid,
    className = '',
    placeholder = 'Επιλέξτε ώρα...',
    step = 1800, // 30 minutes by default
    ...props
}) => {
    const options = {
        locale: Greek,
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        minuteIncrement: step / 60,
        allowInput: false,
        disableMobile: true,
        ...props
    }

    // Convert time string (HH:mm) to a full date for Flatpickr
    const getDateFromTimeString = (timeStr) => {
        if (!timeStr) return null
        const today = new Date()
        const [hours, minutes] = timeStr.split(':').map(Number)
        today.setHours(hours || 0, minutes || 0, 0, 0)
        return today
    }

    // Convert time from "0900" format to "09:00" format
    const formatTimeString = (time) => {
        if (!time) return ''
        const timeStr = time.toString().padStart(4, '0')
        return `${timeStr.slice(0, 2)}:${timeStr.slice(2)}`
    }

    // Convert time from "09:00" format to "0900" format
    const unformatTimeString = (time) => {
        if (!time) return ''
        return time.replace(':', '')
    }

    return (
        <Form.Group>
            {label && <Form.Label className="small text-muted mb-1">{label}</Form.Label>}
            <div className="d-flex gap-2">
                <div className={`flex-grow-1 ${className}`}>
                    <Flatpickr
                        value={getDateFromTimeString(formatTimeString(value))}
                        onChange={([date]) => {
                            if (!date) {
                                onChange('')
                                return
                            }
                            const hours = date.getHours().toString().padStart(2, '0')
                            const minutes = date.getMinutes().toString().padStart(2, '0')
                            onChange(unformatTimeString(`${hours}:${minutes}`))
                        }}
                        options={options}
                        className={`form-control ${isInvalid ? 'is-invalid' : ''}`}
                        disabled={disabled}
                        placeholder={placeholder}
                    />
                    <style>
                        {`
                        .flatpickr-input[readonly] {
                            background-color: #fff !important;
                            cursor: pointer;
                            opacity: 1;
                            color: #212529;
                        }
                        .flatpickr-input[readonly]:disabled {
                            background-color: #e9ecef !important;
                            cursor: not-allowed;
                            opacity: 0.65;
                        }
                        `}
                    </style>
                </div>
                {showClearButton && (
                    <Button
                        variant="outline-secondary"
                        className="time-picker-clear-btn"
                        onClick={() => {
                            onChange('')
                            onClear?.()
                        }}
                        disabled={disabled || !value}
                    >
                        <i className="fas fa-times" />
                    </Button>
                )}
            </div>
        </Form.Group>
    )
}

export default TimePicker 